/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-02 16:31:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-20 10:57:54
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Input/Input.tsx
 */
import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Input as InputAntd } from 'antd';
import React, { ReactNode } from 'react';
import { EnumFormItemStatus } from 'src/types/common/validation';
import { controlSymbolFilter } from '../../../tools/helper';
import css from './Input.less';

interface IProps {
  formProps?;
  id?;
  className?;
  prefix?;
  onPressEnter?;
  onChange?;
  value?;
  placeholder?;
  allowClear?;
  maxLength?;
  size?;
  autoFocus?;
  suffix?;
  error?: boolean;
  help?: string | ReactNode;
  onBlur?: any;
  onClick?: any;
  style?: any;
  customFilter?: (a: string) => string;
  disabled?: boolean;
  fullyControlledFilter?;
  onFocus?;
  onCompositionStart?;
  onCompositionEnd?;
  onKeyUp?;
  iconRender?;
  ref?;
  noErrorDisplay?;
}

//const isInputComposition = false;
//const isChrome = navigator.userAgent.indexOf('Chrome') > -1;

const Input = (props: IProps) => {
  const {
    className,
    onChange,
    prefix,
    suffix,
    onPressEnter,
    value,
    placeholder,
    allowClear,
    maxLength,
    size,
    autoFocus,
    error,
    help,
    onClick,
    customFilter,
    style,
    fullyControlledFilter,
    id,
    formProps = {},
    onBlur,
    noErrorDisplay,
    ...rest
  } = props;
  //const isInputComposition = React.useRef(false);

  const textOnchange = (e) => {
    if (onChange) {
      let value = e.target.value;
      if (fullyControlledFilter) {
        value = fullyControlledFilter(value);
      } else {
        value = controlSymbolFilter(value);
        if (customFilter) {
          value = customFilter(value);
        }
      }
      onChange(value, e);
    }
  };

  // const handleOnTextChange = (e) => {
  //   console.log(e);
  //   if (!isInputComposition.current) {
  //     textOnchange(e);
  //   }
  // };

  return (
    <FormItem
      {...(!noErrorDisplay &&
        error && {
          status: EnumFormItemStatus.error,
          help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
        })}
      {...formProps}>
      <InputAntd
        id={id}
        onBlur={onBlur}
        //  ${
        //   size === 'large' ? css.largeStyle : ''
        // }
        className={`${css.inputStyle} ${className || ''} `}
        onChange={textOnchange}
        maxLength={maxLength}
        prefix={prefix}
        // ref={ref}
        suffix={suffix}
        autoFocus={autoFocus}
        onPressEnter={onPressEnter}
        placeholder={placeholder}
        value={value}
        allowClear={allowClear}
        size={size}
        onClick={onClick}
        style={style}
        //ref={}
        // onCompositionStart={setHideOnChange.bind(this, true)}
        // onCompositionEnd={c}
        {...rest}
      />
    </FormItem>
  );
};

Input.Password = InputAntd.Password;
export { RefInput, OriInput };
export default Input;
const RefInput = React.forwardRef((props: IProps, ref?: any) => {
  const {
    className,
    onChange,
    prefix,
    suffix,
    onPressEnter,
    value,
    placeholder,
    allowClear,
    maxLength,
    size,
    autoFocus,
    error,
    help,
    onClick,
    customFilter,
    style,
    fullyControlledFilter,
    id,
    formProps = {},
    onBlur,
    ...rest
  } = props;
  //const isInputComposition = React.useRef(false);

  const textOnchange = (e) => {
    if (onChange) {
      let value = e.target.value;
      if (fullyControlledFilter) {
        value = fullyControlledFilter(value);
      } else {
        value = controlSymbolFilter(value);
        if (customFilter) {
          value = customFilter(value);
        }
      }
      onChange(value, e);
    }
  };

  // const handleOnTextChange = (e) => {
  //   console.log(e);
  //   if (!isInputComposition.current) {
  //     textOnchange(e);
  //   }
  // };

  return (
    <FormItem
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}
      {...formProps}>
      <InputAntd
        id={id}
        onBlur={onBlur}
        //  ${
        //   size === 'large' ? css.largeStyle : ''
        // }
        className={`${css.inputStyle} ${className || ''} `}
        onChange={textOnchange}
        maxLength={maxLength}
        prefix={prefix}
        // ref={ref}
        suffix={suffix}
        autoFocus={autoFocus}
        onPressEnter={onPressEnter}
        placeholder={placeholder}
        value={value}
        allowClear={allowClear}
        size={size}
        onClick={onClick}
        style={style}
        ref={ref}
        //ref={}
        // onCompositionStart={setHideOnChange.bind(this, true)}
        // onCompositionEnd={c}
        {...rest}
      />
    </FormItem>
  );
});

const OriInput = (props: IProps) => {
  const {
    className,
    onChange,
    prefix,
    suffix,
    onPressEnter,
    value,
    placeholder,
    allowClear,
    maxLength,
    size,
    autoFocus,
    onClick,
    style,
    id,
    onBlur,
    ...rest
  } = props;
  return (
    <InputAntd
      id={id}
      onBlur={onBlur}
      //  ${
      //   size === 'large' ? css.largeStyle : ''
      // }
      className={`${css.inputStyle} ${className || ''} `}
      onChange={onChange}
      maxLength={maxLength}
      prefix={prefix}
      // ref={ref}
      suffix={suffix}
      autoFocus={autoFocus}
      onPressEnter={onPressEnter}
      placeholder={placeholder}
      value={value}
      allowClear={allowClear}
      size={size}
      onClick={onClick}
      style={style}
      //ref={}
      // onCompositionStart={setHideOnChange.bind(this, true)}
      // onCompositionEnd={c}
      {...rest}
    />
  );
};
